import { render, staticRenderFns } from "./comp_ShopSortSelect.vue?vue&type=template&id=faa94276&scoped=true"
import script from "./comp_ShopSortSelect.vue?vue&type=script&lang=js"
export * from "./comp_ShopSortSelect.vue?vue&type=script&lang=js"
import style0 from "./comp_ShopSortSelect.vue?vue&type=style&index=0&id=faa94276&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa94276",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
